/**
 * Environment Variable Utility
 *
 * Uses Vite's build-time injection (import.meta.env.VITE_*).
 * Variables are baked into the bundle during build.
 */

export const env = {
    PRODUCT_BACKEND_URL: import.meta.env.VITE_PRODUCT_BACKEND_URL || '',
    ORDER_MGMT_API_URL: import.meta.env.VITE_ORDER_MGMT_API_URL || '',
    COMPANY_NAME: import.meta.env.VITE_COMPANY_NAME || '',
    LOGO_URL: import.meta.env.VITE_LOGO_URL || '',
    ENABLE_DARK_MODE: import.meta.env.VITE_ENABLE_DARK_MODE === 'true',
    OAUTH2_URL: import.meta.env.VITE_OAUTH2_URL || '',
    OAUTH2_CLIENT_ID: import.meta.env.VITE_OAUTH2_CLIENT_ID || '',
    OAUTH2_REDIRECT_URI: import.meta.env.VITE_OAUTH2_REDIRECT_URI || '',
    OAUTH2_SCOPE: import.meta.env.VITE_OAUTH2_SCOPE || '',
    CURRENCY_SYMBOL: import.meta.env.VITE_CURRENCY_SYMBOL || '$',
    PEXELS_API: import.meta.env.VITE_PEXELS_API || '',
};

console.log('[ENV] Loaded environment variables:', JSON.stringify(env, null, 2));
